import React from "react";

const MenuIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="41"
        height="24"
        viewBox="0 0 41 24"
      >
        <g id="Group_19" data-name="Group 19" transform="translate(-53 -56)">
          <rect
            id="Rectangle_8"
            data-name="Rectangle 8"
            width="41"
            height="3"
            transform="translate(53 56)"
          />
          <rect
            id="Rectangle_9"
            data-name="Rectangle 9"
            width="41"
            height="3"
            transform="translate(53 66)"
          />
          <rect
            id="Rectangle_10"
            data-name="Rectangle 10"
            width="21"
            height="3"
            transform="translate(53 77)"
          />
        </g>
      </svg>
    </>
  );
};
export default MenuIcon;
